import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { authLogin as actionAuthLogin } from '../../redux/auth/actions';

import styles from './styles.scss';
import { get } from 'lodash';

import { selectAuthenticated } from '../../redux/auth/selectors';
import { selectMe } from '../../redux/me/selectors';

import SignInForm from './components/SignInForm';
import constants from '../../constants';
import qm_logo from './assets/qm_logo.png';
import qmStyles from '../../theme/qmStyles';

const getRedirect = location => {
  if (get(location, 'state.redirect')) {
    return location.state.redirect;
  }

  if (get(location, 'search', '')) {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('redirect')) {
      // dump back full path if we have a redirect
      return {
        pathname:
          location.search.split('redirect=').slice(-1)[0] +
          (location.hash ? location.hash : ''),
      };
      // const pathname = `${urlParams.get('redirect')}`;
      // const { hash } = location;

      // return { pathname, hash };
    }
  }

  return null;
};

class Login extends Component {
  static propTypes = {
    authenticated: PropTypes.bool.isRequired,
    authLogin: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: {},

      redirect: getRedirect(props.location),
    };
  }

  postData = (email, password, options) => {
    const { authLogin } = this.props;

    return authLogin(email, password, options).then(this.navigateMain);
  };

  navigateMain = data => {
    const { history } = this.props;
    const { redirect } = this.state;

    if (redirect) {
      const { pathname, hash } = redirect;
      if (pathname && pathname.includes('app')) {
        history.push(redirect);
      } else if (pathname.includes(constants.BASE_DOMAIN)) {
        window.location.href = `${pathname}${hash || ''}`;
      } else {
        window.location.href = `${constants.BASE_URL}/${pathname}${hash || ''}`;
      }
    } else {
      let path = constants.BASE_URL;
      path = path.replace(/\/?$/, '/');
      path += this.routeLoginRoute(data);
      window.location = path;
    }
  };

  routeLoginRoute = () => {
    const { userData } = this.props;

    if (!userData) return;

    let path = '';
    if (userData && userData.properties && userData.properties.length) {
      path = `properties/${userData.properties[0].id}`;
    } else if (userData && userData.businesses && userData.businesses.length) {
      path = `commercial/${userData.businesses[0].id}`;
    }
    return path;
  };

  render() {
    return (
      <div className={styles.container}>
        <img
          src={qm_logo}
          height={60}
          alt="quartermaster logo"
          style={{ marginTop: qmStyles.doubleGutter }}
        />
        <h3 className={styles.title}>Sign In to Quartermaster</h3>
        <SignInForm {...this.props} onSubmit={this.postData} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: selectAuthenticated(state),
  userData: selectMe(state),
  devTools: state.devTools || null,
});

const bindAction = {
  authLogin: actionAuthLogin,
};

export default connect(
  mapStateToProps,
  bindAction,
)(Login);
